import React, { useState } from "react";
import { Helmet } from "fusion-plugin-react-helmet-async";
import { assetUrl } from "fusion-core";
import {
  getDocumentDownloadURL,
  fetchArchiveList,
} from "../../features/buy/services/buyService";
import { useNavigate } from "fusion-plugin-react-router";
import { handleDownloadPDF } from "../utils/apiUtils";

const main = assetUrl("../../styles/main.css");
const download_icon = assetUrl("../../assets/icons/download_icon.svg");
const file_icon = assetUrl("../../assets/icons/file_icon.svg");

const AccordionItem = ({
  title = "",
  description = "",
  schemeDescriptions = {},
  link = null,
  linkDescription = "",
  isLoading,
  setLoading,
  key = "",
  name = "",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const handleDownloadClick = async (e) => {
    e.stopPropagation();
    setLoading(true);
    try {
      await handleDownloadPDF(navigate, link, name);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="accordion_container">
      {link ? (
        <div className="margin-top-15">
          <div
            className="accordion_link_header"
            onClick={() => setIsOpen(!isOpen)}
          >
            <div className="gap-15">
              <h5 className="accordion_title">
                <img src={file_icon} alt="" />
                {title}
              </h5>
              <button
                aria-label="Download file"
                onClick={handleDownloadClick}
                className="accordion_link"
                disabled={isLoading}
                type="button"
              >
                <h5 className="lh-0 gap-3">
                  {isLoading ? (
                    <div className="pr-20">
                      <div className="loader"></div>
                    </div>
                  ) : (
                    <>
                      Download <img src={download_icon} alt="Download icon" />
                    </>
                  )}
                </h5>
              </button>
            </div>
            {isOpen ? (
              <span>
                <svg
                  width="12"
                  height="9"
                  viewBox="0 0 12 9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 9V5.20001L6 0.600006L0 5.20001V9L6 4.39999L12 9Z"
                    fill="black"
                  />
                </svg>
              </span>
            ) : (
              <span>
                <svg
                  width="12"
                  height="9"
                  viewBox="0 0 12 9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ transform: "rotate(180deg)" }}
                >
                  <path
                    d="M12 9V5.20001L6 0.600006L0 5.20001V9L6 4.39999L12 9Z"
                    fill="black"
                  />
                </svg>
              </span>
            )}
          </div>
          {isOpen && <p className="pre-wrap">{linkDescription}</p>}
        </div>
      ) : (
        <div>
          <div className="accordion_header" onClick={() => setIsOpen(!isOpen)}>
            <h5>{title}</h5>
            {isOpen ? (
              <span>
                <svg
                  width="12"
                  height="9"
                  viewBox="0 0 12 9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 9V5.20001L6 0.600006L0 5.20001V9L6 4.39999L12 9Z"
                    fill="#276EF1"
                  />
                </svg>
              </span>
            ) : (
              <span>
                <svg
                  width="12"
                  height="9"
                  viewBox="0 0 12 9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ transform: "rotate(180deg)" }}
                >
                  <path
                    d="M12 9V5.20001L6 0.600006L0 5.20001V9L6 4.39999L12 9Z"
                    fill="#276EF1"
                  />
                </svg>
              </span>
            )}
          </div>
          {isOpen && (
            <div className="accordion_content gray-text">
              <p className="font-14 padding-bottom-12 border-bottom">
                {description}
              </p>

              {Object.entries(schemeDescriptions)?.map(
                ([key, values], index) => (
                  <div key={index}>
                    {["Header", "Footer", "header", "footer"].includes(key) ? (
                      // Render descriptions without displaying the key
                      Array.isArray(values) ? (
                        values.map((value, i) => {
                          let desc = value; // Assuming value is a string

                          // Check for the "-" prefix
                          if (desc.startsWith("-")) {
                            return (
                              <ul
                                key={i}
                                className="border-bottom padding-bottom-12"
                              >
                                <li className="font-weight-400 font-14">
                                  {desc.slice(1).trim()}
                                </li>
                              </ul>
                            );
                          }

                          // Check for "##-##" separator
                          if (desc.includes("##-##")) {
                            const [part1, part2] = desc.split("##-##", 2);
                            return (
                              <div
                                key={i}
                                className="border-bottom"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <p className="font-weight-400 font-14">
                                  {part1.trim()}
                                </p>
                                <p className="font-weight-400 font-14">
                                  {part2.trim()}
                                </p>
                              </div>
                            );
                          }

                          // Default case for value
                          return (
                            <p
                              key={i}
                              className="font-weight-400 font-14 border-bottom padding-bottom-12"
                            >
                              {desc}
                            </p>
                          );
                        })
                      ) : (
                        <p className="font-weight-400 font-14">{values}</p>
                      )
                    ) : (
                      // For keys that are not "header" or "footer", render key and descriptions as before
                      <>
                        <h5 className="font-14 font-black margin-y-axis border-bottom padding-bottom-12">
                          {key}
                        </h5>
                        {Array.isArray(values) ? (
                          values.map((value, i) => {
                            let desc = value; // Assuming value is a string

                            // Check for the "-" prefix
                            if (desc.startsWith("-")) {
                              return (
                                <ul
                                  key={i}
                                  className="border-bottom padding-bottom-12"
                                >
                                  <li className="font-weight-400 font-14">
                                    {desc.slice(1).trim()}
                                  </li>
                                </ul>
                              );
                            }

                            // Check for "##-##" separator
                            if (desc.includes("##-##")) {
                              const [part1, part2] = desc.split("##-##", 2);
                              return (
                                <div
                                  key={i}
                                  className="border-bottom"
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <p className="font-weight-400 font-14">
                                    {part1.trim()}
                                  </p>
                                  <p className="font-weight-400 font-14">
                                    {part2.trim()}
                                  </p>
                                </div>
                              );
                            }

                            // Default case for value
                            return (
                              <p
                                key={i}
                                className="font-weight-400 font-14 border-bottom padding-bottom-12"
                              >
                                {desc}
                              </p>
                            );
                          })
                        ) : (
                          <p className="font-weight-400 font-14">{values}</p>
                        )}
                      </>
                    )}
                  </div>
                )
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const Accordion = ({
  items = null,
  key = "",
  title = "",
  link = null,
  linkDescription = "",
  isLoading = true,
  setLoading = () => {},
  name = "",
  header = "",
}) => {
  return (
    <div>
      <Helmet>
        <link rel="stylesheet" href={main} />
      </Helmet>
      {link ? (
        <div>
          <AccordionItem
            title={title}
            link={link}
            linkDescription={linkDescription}
            isLoading={isLoading}
            setLoading={setLoading}
            key={key}
            name={name}
          />
        </div>
      ) : (
        <>
          {title && (
            <h5 className="font-16 font-black margin-top-25 margin-bottom-0">
              {title}
            </h5>
          )}
          {items?.map((item, index) => (
            <AccordionItem
              key={index}
              title={item.featureName}
              description={item.schemeFeatureDefinition}
              schemeDescriptions={item.schemeDescriptions || {}}
              isLoading={isLoading}
              setLoading={(isLoading) => setLoading(isLoading)}
            />
          ))}
        </>
      )}
    </div>
  );
};

export default Accordion;
